module.exports = __webpack_public_path__ + "media/bootstrap-icons/layers-half-694c40ee.svg";